import { render, staticRenderFns } from "./PersonCard.vue?vue&type=template&id=bd89eae6&scoped=true&"
import script from "./PersonCard.vue?vue&type=script&lang=js&"
export * from "./PersonCard.vue?vue&type=script&lang=js&"
import style0 from "./PersonCard.vue?vue&type=style&index=0&id=bd89eae6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd89eae6",
  null
  
)

export default component.exports